import styles from './FJSourcePreviewItem.module.less';
import { memo, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FJSourcePreviewItemBtu from './FJSourcePreviewItemBtu';
import FJSourceReviewItemStatus from './FJSourceReviewItemStatus';
import FJVideoPreviewItem from './FJVideoPreviewItem';
import FJConstant from '../../../constants/FJConstant';
import { useMemo } from 'react';
import FJAppConstant from '../../../constants/FJAppConstant';
import FJImagePreviewItem from './FJImagePreviewItem';

const FJSourcePreviewItem = memo(props => {
    const {
        item,
        appType,

        selected = false,
        isShowSelected = false,
        hideSelect = false,
        hideDelete = false,
        hideCompare = true,
        hideDownload = false,
        hideEdit = true,
        isTransparentBG = false,

        onSelected,
        onDelete,
        onDownload,
        reGenerate,
        onPreview,
        onEdit,
    } = props;

    const { imgUrl, id, isLoading, isReload, originalUrl, videoUrl, status } = item;

    const [sourceLoadStatus, setSourceLoadStatus] = useState(FJConstant.LOADING);
    const [sourceOriginLoadStatus, setSourceOriginLoadStatus] = useState(FJConstant.LOADING);
    const [isHover, setIsHover] = useState(false);
    const [isComparison, setIsComparison] = useState(false);
    const videoPreviewItemRef = useRef(null);

    const _onPreview = e => {
        e.stopPropagation();
        if (sourceLoadStatus === FJConstant.LOADING || sourceLoadStatus === FJConstant.ERROR || isLoading || isReload)
            return;
        onPreview(item);
    };

    // FJSourceReviewItemStatus 状态
    const sourceStatus = useMemo(() => {
        if (status === 'progress') {
            return FJConstant.PROGRESS;
        }

        if (status === 'failed') {
            return FJConstant.ERROR;
        }

        if (isReload) {
            return FJConstant.RETRY;
        }

        if (isLoading) {
            return FJConstant.LOADING;
        }

        // 资源加载失败状态和 isReload  status === 'failed' 区分开
        if (sourceLoadStatus === FJConstant.ERROR) {
            return FJConstant.SOURCE_LOADING_ERROR;
        }

        if (sourceLoadStatus === FJConstant.LOADING) {
            return FJConstant.LOADING;
        }

        return sourceLoadStatus;
    }, [status, sourceLoadStatus, isReload, isLoading]);

    // 状态界面需要的特殊数据
    const statusData = useMemo(() => {
        if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
            return {
                generationType: item.generationType,
                originalUrl: item.originalUrl,
            };
        }
    }, [item, appType]);

    const _onReloadOrigin = () => {
        videoPreviewItemRef.current?.sourceOriginReload();
    };

    const _reGenerate = () => {
        reGenerate(id);
    };

    const _onSourceReload = () => {
        videoPreviewItemRef.current?.sourceReload();
    };

    return (
        <div
            className={classNames(styles.box, isShowSelected ? styles.selected : '')}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            onClick={_onPreview}
        >
            {/* 资源预览 */}
            {videoUrl ? (
                <FJVideoPreviewItem
                    ref={videoPreviewItemRef}
                    videoUrl={videoUrl}
                    thumbnailUrl={imgUrl}
                    isLoading={isLoading}
                    sourceLoadStatus={sourceLoadStatus}
                    setSourceLoadStatus={setSourceLoadStatus}
                    isHover={isHover}
                    isTransparentBG={isTransparentBG}
                />
            ) : (
                <FJImagePreviewItem
                    imgUrl={imgUrl}
                    originalUrl={originalUrl}
                    setSourceLoadStatus={setSourceLoadStatus}
                    setSourceOriginLoadStatus={setSourceOriginLoadStatus}
                    isTransparentBG={isTransparentBG}
                />
            )}

            {/* 状态 */}
            <FJSourceReviewItemStatus
                status={sourceStatus}
                data={statusData}
                onSourceReload={_onSourceReload}
                onRetry={_reGenerate}
            />

            {/* 操作按钮 */}
            <FJSourcePreviewItemBtu
                sourceLoadStatus={sourceLoadStatus}
                sourceOriginLoadStatus={sourceOriginLoadStatus}
                isShowSelected={isShowSelected}
                propsIsHover={isHover}
                selected={selected}
                hideSelect={hideSelect}
                hideDelete={hideDelete}
                hideCompare={hideCompare}
                hideDownload={hideDownload}
                hideEdit={hideEdit}
                onSelected={(bool, e) => {
                    onSelected && onSelected(id, bool, e);
                }}
                onDelete={() => {
                    onDelete && onDelete(id);
                }}
                onDownload={callback => {
                    onDownload && onDownload(id, callback);
                }}
                onEdit={callback => {
                    onEdit && onEdit(item, callback);
                }}
                isComparison={isComparison}
                setIsComparison={setIsComparison}
                onReloadOrigin={_onReloadOrigin}
            />
        </div>
    );
});

FJSourcePreviewItem.propTypes = {
    item: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    isShowSelected: PropTypes.bool,
    onSelected: PropTypes.func,
    onDelete: PropTypes.func,
    onDownload: PropTypes.func,
    onEdit: PropTypes.func,
    reGenerate: PropTypes.func,
    onPreview: PropTypes.func,
    hideSelect: PropTypes.bool,
    hideDelete: PropTypes.bool,
    hideCompare: PropTypes.bool,
    hideDownload: PropTypes.bool,
    hideEdit: PropTypes.bool,
    appType: PropTypes.string,
    isTransparentBG: PropTypes.bool,
};

FJSourcePreviewItem.displayName = 'FJSourcePreviewItem';
export default FJSourcePreviewItem;
